import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& h5': {
        marginBottom: 0,
      },
    },
  }),
);
interface Props {
  handleClearFilters: () => void;
  closeFilterPanel: () => void;
}

const FilteringHeader = ({ handleClearFilters, closeFilterPanel }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'results']);

  const [mouseOverClose, setMouseOverClose] = useState<boolean>(false);

  return (
    <div className={classes.header}>
      <Tooltip arrow title={t('reset_to')!}>
        <IconButton aria-label={t('reset')} onClick={handleClearFilters}>
          <RotateLeftIcon />
        </IconButton>
      </Tooltip>
      <Typography variant="h6" gutterBottom>
        {t('results:filters')}
      </Typography>
      <Tooltip arrow title={t('results:close_filter_panel')!}>
        <IconButton
          aria-label={t('results:close_filter_panel')}
          onClick={closeFilterPanel}
          onMouseEnter={() => setMouseOverClose(true)}
          onMouseLeave={() => setMouseOverClose(false)}
        >
          {mouseOverClose ? <CloseIcon /> : <FilterListIcon />}
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default FilteringHeader;
